import type { AdvisorProfileViewProfile } from './AdvisorProfileView.types';

export const getAdvisorName = (profile: AdvisorProfileViewProfile) =>
  [profile.user.firstName, profile.user.lastName].filter(Boolean).join(' ');
